var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _circle, _path75, _circle2, _path76, _circle3, _path77, _circle4, _path78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadingIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 301,
    viewBox: "0 0 494 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.031 42.406C342.741 42.406 352.234 32.9131 352.234 21.203C352.234 9.49291 342.741 0 331.031 0C319.321 0 309.828 9.49291 309.828 21.203C309.828 32.9131 319.321 42.406 331.031 42.406Z",
    fill: "#1F2A37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.13 299.855H29.6623C24.3899 299.855 20.0762 295.542 20.0762 290.269V75.2307C20.0762 69.9583 24.3899 65.6445 29.6623 65.6445H123.13C128.402 65.6445 132.716 69.9583 132.716 75.2307V290.269C132.716 295.542 128.402 299.855 123.13 299.855Z",
    fill: "#C3DDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.85 83.1417H29.9434V282.358H122.85V83.1417Z",
    fill: "#1E429F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2474 295.221C81.8067 295.221 83.8815 293.147 83.8815 290.587C83.8815 288.028 81.8067 285.953 79.2474 285.953C76.688 285.953 74.6133 288.028 74.6133 290.587C74.6133 293.147 76.688 295.221 79.2474 295.221Z",
    fill: "#EBF5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2812 75.1605H90.119",
    stroke: "white",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2537 76.4083H94.1826C93.5155 76.4083 92.9707 75.8626 92.9707 75.1964V75.1253C92.9707 74.4583 93.5163 73.9135 94.1826 73.9135H94.2537C94.9207 73.9135 95.4655 74.4591 95.4655 75.1253V75.1964C95.4663 75.8626 94.9207 76.4083 94.2537 76.4083Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M475.287 299.855H381.821C376.548 299.855 372.234 295.542 372.234 290.269V75.2307C372.234 69.9583 376.548 65.6445 381.821 65.6445H475.288C480.56 65.6445 484.874 69.9583 484.874 75.2307V290.269C484.873 295.542 480.56 299.855 475.287 299.855Z",
    fill: "#C3DDFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M475.008 83.1417H382.102V282.358H475.008V83.1417Z",
    fill: "#1E429F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M431.406 295.221C433.965 295.221 436.04 293.147 436.04 290.587C436.04 288.028 433.965 285.953 431.406 285.953C428.846 285.953 426.771 288.028 426.771 290.587C426.771 293.147 428.846 295.221 431.406 295.221Z",
    fill: "#EBF5FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M417.439 75.1605H442.278",
    stroke: "white",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M446.412 76.4081H446.341C445.674 76.4081 445.129 75.8625 445.129 75.1963V75.1252C445.129 74.4582 445.674 73.9133 446.341 73.9133H446.412C447.079 73.9133 447.624 74.459 447.624 75.1252V75.1963C447.624 75.8625 447.079 76.4081 446.412 76.4081Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M355.815 299.764C354.741 292.711 353.71 267.195 346.065 264.937C337.556 262.425 337.348 278.562 330.41 277.344C320.605 275.622 320.745 289.683 317.242 288.258C302.873 282.417 290.893 299.763 290.893 299.763H355.815V299.764Z",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M343.832 299.681L354.001 258.387C354.697 255.558 357.384 253.685 360.279 254.012C363.337 254.357 365.593 257.032 365.418 260.104L363.029 299.754L343.832 299.681Z",
    fill: "white",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M360.41 254.386L352.83 299.715",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M352.867 262.988C352.867 262.988 354.496 270.971 357.2 273.58",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M364.428 276.531C364.428 276.531 359.604 284.322 355.719 283.889",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M347.34 285.439C347.34 285.439 349.947 291.876 353.835 293.707",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M365.174 258.085C365.174 258.085 362.041 265.474 359.062 264.521",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M230.352 299.764C230.352 299.764 228.014 275.185 239.5 275.106C248.647 275.043 253.221 293.829 253.221 293.829C253.221 293.829 260.54 288.698 267.492 291.388C274.376 294.053 275.176 299.763 275.176 299.763H230.352V299.764Z",
    fill: "white",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M239.133 280.777L244.622 299.764",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.785 252.257H328.773C328.773 252.257 318.457 237.518 302.983 241.674C302.983 241.674 303.302 232.516 294.48 231.477C287.798 230.689 284.779 238.75 284.779 238.75C284.779 238.75 282.749 229.389 271.884 229.399C263.928 229.406 261.437 240.447 261.437 240.447C261.437 240.447 242.302 243.099 240.785 252.257Z",
    fill: "#A4CAFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.1 49.0636H185.064C185.064 49.0636 182.639 37.9812 170.172 37.9812C170.172 37.9812 169.787 23.5812 152.071 23.423C141.368 23.3279 136.973 36.1942 136.973 36.1942C136.973 36.1942 128.121 31.6248 122.037 33.5077C115.954 35.3905 116.955 43.0179 116.955 43.0179C116.955 43.0179 105.408 41.4442 106.1 49.0636Z",
    fill: "#A4CAFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M304.816 46.568L380.538 46.8444C380.538 46.8444 375.439 33.9606 360.898 39.6053C360.898 39.6053 362.033 30.7876 353.584 29.2866C346.822 28.0851 344.561 34.0325 344.561 34.0325C344.561 34.0325 338.322 24.3193 331.538 27.8518C326.38 30.5376 326.324 37.4053 326.324 37.4053C326.324 37.4053 307.233 39.225 304.816 46.568Z",
    fill: "#A4CAFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M207.779 299.764C207.779 299.764 208.561 284.196 199.925 281.301C191.29 278.405 192.883 246.909 179.746 249.081C166.61 251.253 156.858 293.247 141.135 299.764",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M169.197 299.775L164.18 261.146C163.837 258.501 161.583 256.52 158.914 256.52C156.095 256.52 153.767 258.723 153.612 261.538L151.502 299.775H169.197Z",
    fill: "white",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M158.748 256.675L161.052 299.776",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.792 265.352C164.792 265.352 162.437 272.551 159.707 274.648",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M152.781 276.581C152.781 276.581 156.417 284.177 159.997 284.182",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M167.339 285.472C167.339 285.472 164.433 292.044 160.705 293.311",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M154.02 259.772C154.02 259.772 156.136 266.773 158.944 266.21",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M493.247 299.716H0.753906",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M156.471 202.592H77.661C75.8907 202.592 74.3977 201.274 74.178 199.518L68.6292 155.169C68.3672 153.073 70.0008 151.223 72.1122 151.223H162.02C164.131 151.223 165.766 153.073 165.503 155.169L159.954 199.518C159.735 201.274 158.242 202.592 156.471 202.592Z",
    fill: "#F6DECD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M156.615 142.233L108.542 170.227C105.631 171.922 101.862 170.928 100.166 168.016L85.0499 142.057C83.3547 139.145 84.3493 135.376 87.2611 133.681L135.333 105.687C138.245 103.992 142.014 104.986 143.709 107.898L158.826 133.857C160.521 136.768 159.526 140.538 156.615 142.233Z",
    fill: "#EBF5FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9023 137.283L106.714 166.153",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7773 132.696L114.59 161.566",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M105.656 128.109L122.469 156.979",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M113.531 123.522L130.343 152.392",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M121.41 118.935L138.222 147.805",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M129.285 114.348L146.098 143.218",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M137.162 109.761L153.975 138.631",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M427.334 202.592H348.524C346.754 202.592 345.261 201.274 345.041 199.518L339.492 155.169C339.23 153.073 340.864 151.223 342.975 151.223H432.883C434.994 151.223 436.628 153.073 436.366 155.169L430.817 199.518C430.597 201.274 429.104 202.592 427.334 202.592Z",
    fill: "#F6DECD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M348.335 142.233L396.407 170.227C399.319 171.922 403.088 170.928 404.783 168.016L419.9 142.057C421.595 139.145 420.6 135.376 417.689 133.681L369.616 105.687C366.705 103.992 362.936 104.986 361.241 107.898L346.124 133.857C344.429 136.768 345.424 140.538 348.335 142.233Z",
    fill: "#EBF5FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M415.049 137.283L398.236 166.153",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M407.174 132.696L390.361 161.566",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M399.296 128.109L382.484 156.979",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M391.42 123.522L374.607 152.392",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M383.543 118.935L366.73 147.805",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M375.665 114.348L358.854 143.218",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M367.788 109.761L350.977 138.631",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M281.492 130.923L225.863 130.89C222.494 130.888 219.739 128.13 219.74 124.76L219.758 94.7206C219.76 91.3519 222.518 88.5967 225.887 88.5983L281.517 88.631C284.885 88.6334 287.641 91.391 287.639 94.7606L287.621 124.8C287.619 128.17 284.861 130.925 281.492 130.923Z",
    fill: "#EBF5FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M226.354 93.0397L226.334 126.449",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M235.469 93.0454L235.449 126.454",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M244.584 93.0508L244.564 126.459",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M253.7 93.0565L253.68 126.465",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M262.817 93.0621L262.797 126.471",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M271.93 93.0668L271.91 126.476",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M281.045 93.0725L281.025 126.481",
    stroke: "#1E429F",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M292.748 197.5H212.506",
    stroke: "#1E429F",
    strokeWidth: 3.19539,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M225.009 207.464L212.203 197.5",
    stroke: "#1E429F",
    strokeWidth: 3.19539,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M212.203 197.5L225.009 187.536",
    stroke: "#1E429F",
    strokeWidth: 3.19539,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M212.203 168.767H292.444",
    stroke: "#1E429F",
    strokeWidth: 3.19539,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M279.943 158.803L292.749 168.767",
    stroke: "#1E429F",
    strokeWidth: 3.19539,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M292.749 168.767L279.943 178.73",
    stroke: "#1E429F",
    strokeWidth: 3.19539,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8495 162.105V161.598C84.8495 159.659 83.2781 158.088 81.3393 158.088H66.2994C64.2464 158.088 62.6319 159.842 62.8013 161.888L67.0919 213.765C67.2421 215.586 68.7639 216.986 70.59 216.986H163.582C165.392 216.986 166.906 215.61 167.077 213.807L171.282 169.459C171.478 167.398 169.857 165.617 167.787 165.617H88.3604C86.4208 165.615 84.8495 164.044 84.8495 162.105Z",
    fill: "#1F2A37"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M355.713 162.105V161.598C355.713 159.659 354.141 158.088 352.203 158.088H337.163C335.11 158.088 333.495 159.842 333.665 161.888L337.955 213.765C338.105 215.586 339.627 216.986 341.453 216.986H434.446C436.256 216.986 437.77 215.61 437.94 213.807L442.146 169.459C442.341 167.398 440.72 165.617 438.651 165.617H359.224C357.285 165.615 355.713 164.044 355.713 162.105Z",
    fill: "#1F2A37"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0938 165.265C83.0938 165.265 80.2364 163.361 72.9636 163.187C65.6909 163.014 63.3359 168.358 63.3359 168.358C63.3359 168.358 69.2634 179.97 81.7957 178.297C92.1855 176.908 93.8415 165.616 93.8415 165.616L83.0938 165.265Z",
    fill: "#B73400"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60946 295.908H10.3591C10.6667 295.908 10.9686 295.977 11.2426 296.117C11.8242 296.412 13.0312 296.954 14.6233 297.272C16.634 297.674 20.4238 296.094 22.8898 298.737C23.3372 299.216 23.0144 299.999 22.3594 299.999H6.70117L7.60946 295.908Z",
    fill: "#252639"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2993 227.919C18.7425 230.203 18.6155 234.208 18.6322 238.272C18.6538 243.684 18.9286 249.201 18.78 250.907C18.5204 253.894 11.2469 260.777 10.5982 266.751C9.94875 272.726 7.61133 295.193 7.61133 296.233C7.61133 297.272 10.2092 296.622 10.5982 296.233C10.8978 295.933 28.5164 256.573 36.6766 238.322C39.1418 232.807 40.7459 229.217 40.7459 229.217L19.2993 227.919Z",
    fill: "#F6DECD"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2598 228.299C37.3828 230.647 38.4117 234.519 39.5956 238.408C41.1709 243.584 43.0195 248.791 43.3678 250.467C43.9773 253.403 38.9885 262.086 40.0829 267.995C41.1773 273.904 45.3936 296.097 45.6924 297.091C45.9912 298.087 48.2926 296.718 48.5539 296.233C48.7544 295.861 54.3207 253.098 56.8938 233.271C57.6711 227.281 58.1752 223.382 58.1752 223.382L37.2598 228.299Z",
    fill: "#F6DECD"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M105.602 142.202C105.602 142.202 106.77 139.799 107.615 138.435C108.459 137.072 110.927 136.747 112.42 137.851C113.913 138.955 113.588 141.287 111.964 142.521C110.341 143.754 107.484 144.734 107.484 144.734L105.602 142.202Z",
    fill: "#F6DECD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1518 122.364L36.5102 118.175L33.9746 142.916H41.7019V139.028V131.422L38.1518 122.364Z",
    fill: "#F6DECD"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M108.725 143.867L106.522 141.728C105.889 141.114 104.892 141.083 104.221 141.656L83.1286 159.719C82.3832 160.357 81.3279 160.484 80.454 160.037C75.1577 157.332 56.9264 148.019 53.7142 146.358C49.9476 144.409 41.7011 142.916 41.7011 142.916H33.1167C28.7438 142.916 25.3096 144.454 23.4834 148.427C22.1038 151.43 21.2187 154.882 21.2722 159.854C21.4024 171.933 23.8429 183.632 23.8429 183.632L15.0803 229.462C14.8199 230.825 15.7649 232.129 17.143 232.295C20.713 232.727 28.0097 233.415 38.7781 233.504C50.4477 233.6 60.2863 231.44 64.66 230.297C65.9925 229.948 66.753 228.554 66.3336 227.243L51.376 180.515L53.9802 164.36L76.1283 173.828C79.1679 174.953 82.5206 174.886 85.5123 173.64C87.5686 172.784 89.366 171.406 90.7272 169.643L108.887 146.136C109.419 145.449 109.349 144.472 108.725 143.867Z",
    fill: "#1F2A37"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9692 133.89C39.4168 133.89 36.5098 130.983 36.5098 127.431V119.441C36.5098 115.888 39.4168 112.981 42.9692 112.981C46.5217 112.981 49.4287 115.888 49.4287 119.441V127.431C49.4287 130.983 46.5217 133.89 42.9692 133.89Z",
    fill: "#F6DECD"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M46.239 294.59L47.426 294.65C48.0699 294.683 48.697 294.88 49.2314 295.24C49.9975 295.754 51.2709 296.495 52.6098 296.794C54.7531 297.272 57.2199 296.753 58.5843 297.207C59.2538 297.43 60.0798 298.108 60.7476 298.739C61.2277 299.194 60.913 300 60.2515 300H45.7325C44.988 300 44.4272 299.323 44.5662 298.591L45.1677 295.432C45.2652 294.923 45.7221 294.564 46.239 294.59Z",
    fill: "#252639"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4292 120.794C50.4292 120.794 46.5748 126.078 41.0739 125.04L40.1481 146.391H24.704C24.704 146.391 22.2243 113.923 35.645 111.412C43.9634 109.854 50.4292 113.694 50.4292 120.794Z",
    fill: "#252639"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M25.168 183.751C25.168 183.751 38.6749 186.349 50.4283 181.673",
    stroke: "white",
    strokeWidth: 0.798847,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.465,
    cy: 104.745,
    r: 0.798847,
    fill: "#C3DDFD"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M155.662 102.073C166.422 98.3927 188.035 92.1522 212.149 91.6185",
    stroke: "#C3DDFD",
    strokeWidth: 1.59769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 91.5835,
    r: 0.798847,
    fill: "#C3DDFD"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M164.023 137.187C164.023 137.187 188.639 125.362 216 126.482",
    stroke: "#C3DDFD",
    strokeWidth: 1.59769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.01 7.99"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.979,
    cy: 104.745,
    r: 0.798847,
    fill: "#C3DDFD"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M352.957 101.599C343.411 97.8752 324.264 92.1099 296.301 91.6178",
    stroke: "#C3DDFD",
    strokeWidth: 1.59769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.443,
    cy: 91.5835,
    r: 0.798847,
    fill: "#C3DDFD"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M342.677 136.454C342.677 136.454 317.993 125.362 290.633 126.482",
    stroke: "#C3DDFD",
    strokeWidth: 1.59769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.01 7.99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingIllustration);
export default __webpack_public_path__ + "static/media/uploading-illustration.a78a0119b89c9fb13739febe407fb8fa.svg";
export { ForwardRef as ReactComponent };